/**
 * Pobiera typ medium typu MIME pliku
 *
 * @param {String} mime - typ MIME
 * @returns {String} - pierwszy człon typu MIME pliku
 */
export default mime => mime.split('/')[0];
